import React, { useState } from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
    height: '100vh',

    '& .helperText': {
      fontSize: '.8rem',
      marginLeft: '.2rem',
    },
  },
}));

const WeekDays = ({ weekDays, setWeekDays }) => {
  const classes = useStyles();
  const initialDays = ['SAT', 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI'];
  const handleChange = (e) => {
    const { name, checked } = e.target;
    if (checked === true) {
      return setWeekDays([...weekDays, name]);
    } else {
      const filteredDays = weekDays.filter((item) => item !== name);
      return setWeekDays([...filteredDays]);
    }
  };
  const handleSelectAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      return setWeekDays([...initialDays]);
    } else {
      return setWeekDays([]);
    }
  };
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className={classes.heading}>رزرو روز های هفته</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div className="checkBoxes">
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel component="legend">
              روزهای خود برای رزرو را انتخاب کنید:
            </FormLabel>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weekDays.length === 7}
                    onChange={handleSelectAll}
                    name="ALL"
                  />
                }
                label="رزرو همه ی روزها"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weekDays.includes('SAT')}
                    onChange={handleChange}
                    name="SAT"
                  />
                }
                label="شنبه"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weekDays.includes('SUN')}
                    onChange={handleChange}
                    name="SUN"
                  />
                }
                label="یکشنبه"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weekDays.includes('MON')}
                    onChange={handleChange}
                    name="MON"
                  />
                }
                label="دوشنبه"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weekDays.includes('TUE')}
                    onChange={handleChange}
                    name="TUE"
                  />
                }
                label="سه شنبه"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weekDays.includes('WED')}
                    onChange={handleChange}
                    name="WED"
                  />
                }
                label="چهارشنبه"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weekDays.includes('THU')}
                    onChange={handleChange}
                    name="THU"
                  />
                }
                label="پنجشنبه"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weekDays.includes('FRI')}
                    onChange={handleChange}
                    name="FRI"
                  />
                }
                label="جمعه"
              />
            </FormGroup>
          </FormControl>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default WeekDays;
